import {createFetchClientWithAuth} from '../util/request/middleware'
import {camelCase as camelCaseObject} from 'change-case-object'

const client = createFetchClientWithAuth('v1/notification')

/**
 * Register a device for push notifications
 * @param deviceId
 * @param os
 * @param token
 * @returns {number}
 */
export async function registerForPushNotifications(deviceId, os, token){
	const response = await client.post(`register`, {
		body: {
			deviceId: deviceId,
			deviceOS: os,
			RegistrationCode: token
		}
	})

	return response.ClientNotificationId
}

/**
 * Fetches the uses notification history
 * @url https://developmentmybudgetapi.azurewebsites.net/swagger/ui/index#!/Notification/NotificationHistory_GetNotificationHistory
 * @param count
 * @param offset
 * @returns {Promise.<void>}
 */
export async function getNotificationHistory(count=20, offset=0){
	return camelCaseObject(await client.get(`history`, {
		query: {
			Count: count,
			Offset: offset
		}
	}))
}



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/lib/api/notification.js